import { render, staticRenderFns } from "./sealRuleEdit.vue?vue&type=template&id=1377989a&scoped=true"
import script from "./sealRuleEdit.vue?vue&type=script&lang=js"
export * from "./sealRuleEdit.vue?vue&type=script&lang=js"
import style0 from "./sealRuleEdit.vue?vue&type=style&index=0&id=1377989a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377989a",
  null
  
)

export default component.exports